export default __webpack_public_path__ + "static/media/backgroundCredpal.192fc490.svg";